import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SET_IS_WITHOUT_MINIMAL_BET = 'PUBLISH_TERMS :: IS_WITHOUT_MINIMAL_BET :: SET';

export type TSetIsWithoutMinimalBetAction = IReduxAction<typeof SET_IS_WITHOUT_MINIMAL_BET, boolean>;

export const setIsWithoutMinimalBet = actionGenerator<typeof SET_IS_WITHOUT_MINIMAL_BET, boolean>(
  SET_IS_WITHOUT_MINIMAL_BET,
);
